import styled from "styled-components";

export const Wrapper = styled.div`
    align-self: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 88vh;

`;
export const Container = styled.div`
    /* display: flex;
    justify-content: center;
    flex-direction: column; */
    align-self: center;
    box-shadow: 0px 15px 41px -16px rgba(0,0,0,0.61);
    /* padding: 20px; */
    min-height: 51vh;
    width: 50%;
    padding: 40px 10px;
    h1{
        font-size: 24px;
    }
    form{
        padding: 0px 50px;
        
    }
    @media only screen and (max-width: 992px) {
        width: 100%;
        padding: 40px 5px;
    h1{
        font-size: 18px;
    }
    form{
        padding: 0px 5px 0px 0px;
        
    }

    }
`;